<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        series: {
          type: "sankey",
          data: [
            { name: "Node A" },
            { name: "Node B" },
            { name: "Node C" },
            { name: "Node D" }
          ],
          links: [
            { source: "Node A", target: "Node B", value: 5 },
            { source: "Node A", target: "Node C", value: 3 },
            { source: "Node B", target: "Node D", value: 2 },
            { source: "Node C", target: "Node D", value: 8 }
          ]
        }
      }
    };
  }
};
</script>
